import type { ReactNode } from 'react';
import styles from './summary-note.module.css';

type SummaryNoteTone = 'warning' | 'hint';

type SummaryNoteProps = {
  tone: SummaryNoteTone;
  children: ReactNode;
};

export const SummaryNote = ({ tone, children }: SummaryNoteProps) => {
  const isWarning = tone === 'warning';

  return (
    <p className={isWarning ? styles.warning : styles.hint} role={isWarning ? 'alert' : undefined}>
      {children}
    </p>
  );
};
